import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo } from 'react';
import { AiOutlineClear, AiOutlineSearch } from 'react-icons/ai';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useReportStore } from '../../stores/ReportStore';
import { convertDateIntoMillis } from '../../utils/luxon';
import CustomerDropDown from '../CommonComponent/DropdownComponent/CustomerDropdown';
import { useCommonStore } from '../../stores/CommonStore';
import { ICommonState } from '../../model/CommonModel';
import { dropDownMapping } from '../../utils/app-common';
import FFDCustomerDropDown from '../CommonComponent/DropdownComponent/FFDCustomerDropDown';


const initialValues = {
    subClientId: undefined,
    startDeliveryDate: undefined,
    endDeliveryDate: undefined,
    industryGroupId: undefined,
}

const FFDBookingFilterReportComponent = ({
    onSearchClicked
}) => {
    const { promiseInProgress: customerProgress } = usePromiseTracker({ area: 'customer-area' })
    const [form] = Form.useForm();
    const GetIndustriesGroupList = useCommonStore((state: ICommonState) => state?.GetIndustriesGroupListAction);
    const industryGroupList = useCommonStore((state: ICommonState) => state?.industryGroupList);
    const industryGroupListMemo = useMemo(() => dropDownMapping(industryGroupList, 'id', 'name'), [industryGroupList]);


    useEffect(() => {
        trackPromise(GetIndustriesGroupList(), 'customer-area');
    }, [GetIndustriesGroupList])


    const onFilterClick = useCallback((values) => {
        const { startEndDate, ...rest } = values || {};
        const request = {
            ...rest,
            subClientId: values?.subClientId,
            industryGroupId: values?.industryGroupId,
            startDeliveryDate: convertDateIntoMillis(values?.startEndDate?.[0]),
            endDeliveryDate: convertDateIntoMillis(values?.startEndDate?.[1]),
        }

        onSearchClicked({ ...request });
    }, [
        onSearchClicked
    ])

    const onReset = () => {
        form?.resetFields();
        // onResetClicked?.();
    };


    return (
        <Form
            name='filter'
            initialValues={initialValues}
            onFinish={onFilterClick}
            form={form}
            preserve={false}
        >
            <Row gutter={1} justify={'start'} align='top' wrap={true}>
                <Col span={5} style={{ overflowX: "auto", margin: 0, padding: 0 }}>
                    <FFDCustomerDropDown showAll={true} />
                </Col>
                <Col span={5} md={5} lg={5} xl={5} sm={8} xs={8}>
                    <Form.Item name='industryGroupId' label='Industry Group' labelCol={{ span: 24 }} >
                        <Select
                            showSearch
                            allowClear
                            loading={customerProgress}
                        >
                            {industryGroupListMemo?.map((customer, index) => (
                                <React.Fragment key={customer?.id}>
                                    <Select.Option value={customer?.id} key={customer?.id}>{customer?.value}</Select.Option>
                                </React.Fragment>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={5} >
                    <Form.Item name='startEndDate' label='Start & End Date' labelCol={{ span: 24 }} >
                        <DatePicker.RangePicker allowClear format="DD/MM/YYYY" name='startDate' size={'middle'} className='width_full' />
                    </Form.Item>
                </Col>
                <Space align='center' wrap={false} size={2} style={{ height: '8rem' }}>
                    <Col>
                        <Button data-args={'search'} htmlType="submit" >
                            <AiOutlineSearch size={18}></AiOutlineSearch>
                        </Button>
                    </Col>
                    <Col>
                        <Button htmlType="button" onClick={onReset}>
                            <AiOutlineClear size={18} />
                        </Button>
                    </Col>
                </Space>
            </Row>
        </Form>
    )

};

export default FFDBookingFilterReportComponent;